<template>
  <div :class="[isMaring ? 'boms2' :'boms1','numbers']">

    <div class="p-tit">
      <div class="p-tit-c">
        <div class="p-tit-c-txt">请您留言</div>
        <img :src="open?'/static/imgs/guan.png':'/static/imgs/kai.png'" class="img-sta-bar"
          @click="open=!open" />
      </div>
    </div>

    <div class="form-numer" v-if="open">
      <div class="form-numer-cont" v-if="subject == 'info'">

        <div class="form-numer-cont-tit">
          感谢您对聚木网的关注，请留下您的电话，我们会在第一时间与您联系
        </div>

        <div class="form-numer-cont-xq">
          <textarea placeholder="请输入您的需求，我们会尽快安排工作 人员与您联系" maxlength="300" v-model="form.content"></textarea>
        </div>

        <div class="form-numer-cont-xm">
          <div class="dis">
            <img src="../../static/imgs/renicon.png" class="icon-img-aa" />
            <input placeholder="姓名" class="inpo" v-model="form.name" maxlength="20"></input>
          </div>
        </div>

        <div class="form-numer-cont-dh">
          <div class="dis">
            <img src="../../static/imgs/phoneicon.png" class="icon-img-aa" />
            <input placeholder="电话（必填）" class="inpo" v-model="form.telephone" maxlength="11"></input>
          </div>
        </div>

        <div class="phone-btn" @click="send">
          提交
        </div>
      </div>
      <div class="oads" v-if="subject == 'success' || subject == 'error' ">
        <img src="../../static/imgs/cuowu.png" style="width: 86px;height: 86px;" v-if="subject == 'error' " />
        <img src="../../static/imgs/chenggong.png" style="width: 86px;height: 86px;" v-if="subject == 'success' " />
        <div class="yuyan">
          {{subject == 'success' ? '感谢留言' :'提交失败'}}<br />
          {{subject == 'success' ? '我们会尽快与您联系' :'提交失败请刷新重试'}}
        </div>

        <div class="anniu cupo" @click="subject='info'">
          {{subject == 'success' ? '关闭' :'返回'}}
        </div>
      </div>

    </div>
  </div>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        subject: 'info',
        open: true,
        isMaring: false,
        form: {
          content: '',
          telephone: '',
          name: '',

        }
      }
    },

    watch: {
      $route(to, from) {
        if (to.path == '/settled') {
          this.isMaring = true
        } else {
          this.isMaring = false
        }
      }
    },

    methods: {
      send() {
        const phoneRegex = /^1[3-9]\d{9}$/;
        if (!phoneRegex.test(this.form.telephone)) {
          this.$notify.error({
            title: '错误',
            message: '请检查电话格式！',
            position: 'top-left'
          });
          return
        }
        this.$request('post', this.$wxapi + 'reservedinfo/official-site/add', this.form, (res) => {
          if (res.status == 200) {
            this.form = {
              content: '',
              telephone: '',
              name: ''
            }
            this.subject = 'success'
            // this.$alert('感谢留言，我们会尽快与您联系', '提交成功', {
            //   confirmButtonText: '确定',
            // });
          } else {
            this.subject = 'error'
            // this.$notify.error({
            //   title: '错误',
            //   message: '提交失败，请重试！',
            //   position: 'top-left'
            // });
          }
        })
      }
    }
  }
</script>

<style scoped>
  .numbers {
    position: fixed;
    left: 0;
    width: 250px;
    background: #fff;

    left: 50px;
    border-radius: 12px;
    z-index: 1000;
    box-shadow: 0px 0px 8px 0px rgba(0, 0, 0, 0.15)
  }

  .boms1 {
    bottom: 40px;
  }

  .boms2 {
    bottom: 160px;
  }


  .form-numer {
    width: 100%;
  }


  .p-tit {
    width: 100%;
    height: 37px;
    background: #2F7BFF;
    border-radius: 12px 12px 0 0;
  }

  .p-tit-c {
    padding: 13px 22px 9px 22px;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .p-tit-c-txt {
    font-weight: 400;
    font-size: 12px;
    color: #FFFFFF;
  }

  .img-sta-bar {
    width: 18px;
    height: 18px;
    cursor: pointer;
  }

  .form-numer-cont {
    padding: 13px 12px;
    overflow: hidden;
  }

  .form-numer-cont-tit {
    font-weight: bold;
    font-size: 14px;
    color: #333333;
    text-align: left;
    margin-bottom: 10px;
    padding: 0 8px;
  }

  .form-numer-cont-xq {
    width: 100%;
    height: 77px;
    background: rgba(217, 217, 217, 0.1);
    border-radius: 4px 4px 4px 4px;
    border: 1px solid #D9D9D9;
    margin-bottom: 10px;
  }

  input:focus,
  textarea:focus {
    outline: none;
    /* 去掉聚焦时的默认外轮廓 */
  }


  input::placeholder,
  textarea::placeholder {
    color: #B9B9B9;
    font-size: 12px;
    /* 设置 placeholder 字体颜色 */
  }

  textarea {
    background: none;
    display: block;
    width: 92%;
    height: 80%;
    resize: none;
    border: none;
    margin: 2% auto;

  }

  .form-numer-cont-xm {
    width: 100%;
    height: 31px;
    margin-bottom: 10px;
    background: rgba(217, 217, 217, 0.1);
    border-radius: 4px 4px 4px 4px;
    border: 1px solid #D9D9D9;
  }

  .form-numer-cont-dh {
    width: 100%;
    height: 31px;
    background: rgba(217, 217, 217, 0.1);
    border-radius: 4px 4px 4px 4px;
    border: 1px solid #D9D9D9;
    margin-bottom: 12px;
  }

  .icon-img-aa {
    width: 17px;
    height: 17px;
    margin-left: 5px;
  }

  .dis {
    justify-content: space-around;
    height: 100%;
  }

  .inpo {
    width: 83%;
    height: 70%;
    border: none;
    background: none;
  }

  .phone-btn {
    width: 60px;
    height: 25px;
    background: #2F7BFF;
    border-radius: 4px 4px 4px 4px;
    text-align: center;
    line-height: 25px;
    color: #fff;
    font-weight: 400;
    font-size: 12px;
    float: right;
    cursor: pointer;
  }

  .oads {
    padding: 50px 62px;
    text-align: center;
  }

  .yuyan {
    font-size: 14px;
    color: #000;
    margin-bottom: 20px;
  }

  .anniu {
    width: 60px;
    height: 25px;
    font-size: 12px;
    margin: 0 auto;
    background: #2F7BFF;
    border-radius: 4px 4px 4px 4px;
    text-align: center;
    line-height: 25px;
    color: #fff;
  }
</style>



// WEBPACK FOOTER //
// src/components/leaveNumer.vue